/**
 * CCW Duplicate Guard (CHR-13/14)
 *
 * Keeps the product-page duplicate-purchase warning in sync with the cart after
 * AJAX changes (theme cart events + any /cart/*.js mutation). Initial state is server-rendered by the
 * 'ccw-duplicate-warning' snippet; the cart page re-renders itself through the
 * theme's own section refresh, so this module only manages the product page.
 *
 * Debug: window.CCWDuplicateGuard.state / .check(productId) / .refresh()
 */
(function () {
  'use strict';

  var SECTION_ID = 'ccw-bundle-map';
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var state = { bundles: [], itemProductIds: [], items: [] };
  var refreshTimer = null;

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root;
  }

  function findBundleFor(productId) {
    var id = Number(productId);
    for (var i = 0; i < state.bundles.length; i++) {
      if (state.bundles[i].includes.indexOf(id) !== -1) return state.bundles[i];
    }
    return null;
  }

  function applyToProductPage() {
    var el = document.querySelector('[data-ccw-duplicate-warning]');
    if (!el) return;
    var bundle = findBundleFor(el.getAttribute('data-ccw-product-id'));
    if (bundle) {
      var title = el.querySelector('[data-ccw-bundle-title]');
      if (title) title.textContent = bundle.title;
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  }

  function refresh() {
    return fetch(rootUrl() + '?sections=' + SECTION_ID)
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var html = sections[SECTION_ID];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var json = doc.querySelector('[data-ccw-bundle-map]');
        if (!json) return;
        state = JSON.parse(json.textContent);
        applyToProductPage();
      })
      .catch(function () { /* leave last known state in place */ });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 400);
  }

  // Theme pub/sub (Minimog) — fires for the theme's own cart operations.
  if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, scheduleRefresh);
  }
  document.addEventListener('cart:updated', scheduleRefresh);

  // Network-level fallback — catches cart mutations from app embeds (e.g. UpCart).
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = origFetch.apply(this, arguments);
    if (CART_MUTATION_RE.test(url)) {
      result.then(scheduleRefresh, function () {});
    }
    return result;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && CART_MUTATION_RE.test(String(url))) {
      this.addEventListener('loadend', scheduleRefresh);
    }
    return origOpen.apply(this, arguments);
  };

  // Seed state once so the debug API works before any cart mutation.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); });
  } else {
    refresh();
  }

  window.CCWDuplicateGuard = {
    get state() { return state; },
    check: function (productId) { return findBundleFor(productId); },
    refresh: refresh,
  };
})();
